import axios from "axios";

const apiUrl = process.env.REACT_APP_PYTHON_API_BASE_URL;
const token = process.env.REACT_APP_TOKEN;

export const translateText = async (text, fromLanguage, toLanguage) => {
  try {
    let endpoint = "";
    let requestData = {};

    if (fromLanguage === "English" && toLanguage === "Yoruba") {
      endpoint = "/translate/english_to_yoruba";
      requestData = { english_text: text };
    } else if (fromLanguage === "Yoruba" && toLanguage === "English") {
      endpoint = "/translate/yoruba_to_english";
      requestData = { yoruba_text: text };
    } else if (fromLanguage === "English" && toLanguage === "Swahili") {
      endpoint = "/translate/english_to_swahili";
      requestData = { english_text: text };
    } else if (fromLanguage === "Swahili" && toLanguage === "English") {
      endpoint = "/translate/swahili_to_english";
      requestData = { swahili_text: text };
    } else if (fromLanguage === "English" && toLanguage === "Nigerian Pidgin") {
      endpoint = "/translate/english_to_pidgin";
      requestData = { english_text: text };
    } else if (fromLanguage === "Nigerian Pidgin" && toLanguage === "English") {
      endpoint = "/translate/pidgin_to_english";
      requestData = { nigerian_pidgin_text: text };
    } else {
      throw new Error("Unsupported language translation");
    }

    const response = await axios.post(`${apiUrl}${endpoint}`, requestData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.translated_text;
  } catch (error) {
    console.error("Translation error:", error);
    return null;
  }
};

// --- Website Translator APIs ---
// These are stub functions that will eventually connect to your new Node/NestJS backend

export const registerWebsite = async (domain, token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_NODE_BASE_URL}/websites`, { domain }, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error("Error registering website:", error);
    return null;
  }
};

export const getWebsiteConfig = async (token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_NODE_BASE_URL}/websites`, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error("Error fetching website config:", error);
    return null;
  }
};

export const updateLanguageSettings = async (settings, token) => {
  try {
    const response = await axios.patch(`${process.env.REACT_APP_API_NODE_BASE_URL}/websites/languages`, settings, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error("Error updating language settings:", error);
    return null;
  }
};

export const regenerateWebsiteApiKey = async (domain, token) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_NODE_BASE_URL}/websites/regenerate-key`, { domain }, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    console.error("Error regenerating API key:", error);
    return null;
  }
};